import type { ApiResult } from "@/types/api";
import type {
  BookingResponseData,
  RentalTempBookingSnapshot,
} from "@/types/booking/checkout";
import dayjs from "dayjs";

export type RentalBookingKeyPayload = {
  rentalId: string;
  contextKey: string;
  key: string;
};

export type RentalBookingResponse = ApiResult<BookingResponseData>;

export const deriveRentalEndDate = (start: string, days: number) => {
  const parsedStart = dayjs(start);
  if (!parsedStart.isValid() || !Number.isInteger(days) || days <= 0) {
    return null;
  }

  return parsedStart.add(days - 1, "day").format("YYYY-MM-DD");
};

export const getRentalDayCount = (start: string, end: string) =>
  Math.max(dayjs(end).diff(dayjs(start), "day") + 1, 1);

export const isRentalTempBookingSnapshot = (
  value: unknown,
): value is RentalTempBookingSnapshot => {
  if (!value || typeof value !== "object") return false;
  const snapshot = value as Partial<RentalTempBookingSnapshot>;
  return snapshot.svcType === "rental" && Boolean(snapshot.rental);
};
